<template>
  <div id="shippersExport">
    <BreadCrumb :items="breadcrumbItems" />

    <v-card elevation="1" class="px-5 mt-1">
      <div class="d-flex justify-space-between align-center pt-5">
        <h1>Dados Exportados</h1>
      </div>
      <div class="d-flex my-5">
        <v-icon class="pr-1">mdi-information-outline</v-icon>
        <div class="info-message">Atenção, apenas os últimos 5 registros serão mantidos.</div>
      </div>

      <div class="table">
        <v-data-table
          :headers="headers"
          :items="receiptsToExport"
          :loading="isLoading"
          :items-per-page="pageSize"
          @update:items-per-page="onItemsPerPageChange"
          :footer-props="{
            'items-per-page-options': [],
            itemsPerPageText: ''
          }"
        >
          <template v-slot:[`item.initialDate`]="{ item }">
            {{ transformDate(item.initialDate) }}
          </template>
          <template v-slot:[`item.dateEnd`]="{ item }">
            {{ transformDate(item.dateEnd) }}
          </template>
          <template v-slot:[`item.requestDate`]="{ item }">
            {{ transformDate(item.requestDate) }}
          </template>
          <template v-slot:[`item.holidays`]="{ item }">
            <copy-to-clipboard-tooltip :text="formatHolidays(item.holidays)"></copy-to-clipboard-tooltip>
          </template>

          <template v-slot:[`item.actions`]="{ item, index }">
            <div>
              <template v-if="isDownloadLoading && index === loadingIndexItem">
                <div>
                  <v-progress-circular indeterminate color="secondary" size="20" width="3"></v-progress-circular>
                </div>
              </template>
              <v-tooltip top v-else>
                <template #activator="{ on, attrs }">
                  <v-icon
                    :disabled="checkIfIsAvaliableToDownload(item.statusName)"
                    @click="onDownloadClick(item.id, index)"
                    v-on="on"
                    v-bind="attrs"
                    >mdi-download</v-icon
                  >
                </template>
                Baixar
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
        <div class="d-flex align-center py-3">
          <v-pagination
            v-model="pageNumber"
            :length="totalPages"
            :total-visible="7"
            @input="onPageChange"
          ></v-pagination>
          <reload-button @click="getAllReports" />
        </div>
      </div>
    </v-card>
    <MessagesError
      :type="errorsType"
      :errors="errors"
      :error500="error500"
      @closeMessages="
        errors = [];
        error500 = null;
      "
    />
  </div>
</template>

<script>
import BreadCrumb from '@/components/BreadCrumb.vue';
import maskData from '@/utils/maskData';
import { formatDate } from '@/handlers/DateHandler';
import ReloadButton from '@/components/ReloadButton';
import { mapActions } from 'vuex';
import MessagesError from '../../../components/MessagesError.vue';
import { FeedbackMessageHandler } from '@/store/modules/feedbackMessageHandler';
import CopyToClipboardTooltip from '@/components/CopyToClipboardTooltip.vue';
export default {
  name: 'ShippersExport',
  components: { BreadCrumb, ReloadButton, MessagesError, CopyToClipboardTooltip },
  data: () => ({
    date: null,
    dates: [],
    isHolidaysOpen: false,
    isInitialDateOpen: false,
    isEndDateOpen: false,
    isDownloadLoading: false,
    loadingIndexItem: null,
    initialDate: null,
    endDate: null,
    isLoading: false,
    pageNumber: 1,
    totalPages: 1,
    pageSize: 10,
    errorsType: null,
    errors: [],
    error500: null,
    receiptsToExport: [],
    headers: [
      { text: 'DATA DA SOLICITAÇÃO', value: 'requestDate', align: 'start' },
      { text: 'DATA INICIAL', value: 'initialDate' },
      { text: 'DATA FINAL', value: 'dateEnd' },
      { text: 'FERIADOS', value: 'holidays' },
      { text: 'STATUS', value: 'statusName' },
      { text: 'AÇÕES', value: 'actions' }
    ],
    breadcrumbItems: [
      {
        text: 'Início',
        disabled: false,
        to: '/start'
      },

      {
        text: 'Dados Exportados',
        disabled: true
      }
    ]
  }),

  computed: {
    formattedInitialDate() {
      if (!this.initialDate) return '';
      const [year, month, day] = this.initialDate.split('-');
      return `${day}/${month}/${year}`;
    },
    formattedEndDate() {
      if (!this.endDate) return '';
      const [year, month, day] = this.endDate.split('-');
      return `${day}/${month}/${year}`;
    }
  },
  created() {
    this.getAllReports();
    this.handleFeedback();
  },

  methods: {
    ...mapActions('ReportStore', ['report', 'getReports', 'downloadReport']),
    async getAllReports() {
      try {
        this.isLoading = true;
        this.receiptsToExport = await this.getReports(true);
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async onDownloadClick(id, index) {
      try {
        this.loadingIndexItem = index;
        this.isDownloadLoading = true;
        await this.downloadReport(id);
        this.errorsType = 'success';
        this.errors = ['Download realizado com successo!'];
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingIndexItem = null;
        this.isDownloadLoading = false;
      }
    },
    handleFeedback() {
      const message = FeedbackMessageHandler.getFeedbackMessage(this);
      if (message) {
        this.errorsType = 'success';
        this.errors = [message];
        FeedbackMessageHandler.resetFeedbackMessage(this);
      }
    },
    checkIfIsAvaliableToDownload(statusName) {
      if (statusName.toLowerCase() === 'pronto para download') {
        return false;
      }
      return true;
    },
    formatHolidays(holydays) {
      const formattedHolidaysDates = holydays.map((holiday) => this.transformDate(holiday));
      const stringHolidays = formattedHolidaysDates.join(', ');
      return stringHolidays;
    },
    onItemsPerPageChange(pageSize) {
      this.pageSize = pageSize;
      //   this.getAllShippers();
    },
    onPageChange(pageNumber) {
      this.pageNumber = pageNumber;
      //this.getAllDeliveries();
    },
    transformDate(date) {
      return maskData(date);
    },
    onDateClick(date) {
      var index = this.dates.findIndex((x) => x === date);

      if (index === -1) {
        this.dates.push(date);
      } else {
        this.dates.splice(index, 1);
      }
    },
    onCloseClick(date) {
      const index = this.dates.indexOf(date);
      this.dates.splice(index, 1);
    },
    getFormattedDate(dt_string) {
      return formatDate(dt_string);
    }
  }
};
</script>

<style lang="scss" scoped>
.info-message {
  color: gray;
}
::v-deep .v-select__selections {
  padding-left: 35px !important;
}
::v-deep .v-pagination.v-pagination {
  justify-content: start;
  position: inherit;
  width: auto;
}
</style>
